import React from "react";

const MobileFilterSection = ({
  changeDeliveryDetails,
  getFilter,
  handleFilterSection
}) => (
  <div className="rest-breadcrumb white-bg d-flex justify-content-between align-items-center visible-xs">
    <a href="javascript: void(0)" onClick={changeDeliveryDetails}>
      <p> {getFilter()} </p>
    </a>
    <i onClick={handleFilterSection} className="icon icon-restaurant-filter" />
  </div>
);

export default MobileFilterSection;
